import { render, staticRenderFns } from "./dubdetail.vue?vue&type=template&id=6e035c2a&scoped=true&"
import script from "./dubdetail.vue?vue&type=script&lang=js&"
export * from "./dubdetail.vue?vue&type=script&lang=js&"
import style0 from "./dubdetail.vue?vue&type=style&index=0&id=6e035c2a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e035c2a",
  null
  
)

export default component.exports